// extracted by mini-css-extract-plugin
module.exports = {"container":"NoSearchResults_container__DoItH","emoji":"NoSearchResults_emoji__k7T_f","message":"NoSearchResults_message__v8PG3"};